import ImportProductContainer from './ImportProducts';
import './importProducts.scss';

export default {
  title: 'Import Products',
  description: '',
  path: '/setup/import-products',
  component: ImportProductContainer,
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'Import Products' }],
};
